module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_s60@2x-8ae79b6eeb0b497e89d64404be84f117.png";